/*
 * instant-cart-sync.js
 * --------------------------------------------------------------------------
 * Überlebt Instant-Template-Overwrites (liegt als eigenes Asset vor und wird
 * in theme.liquid eingebunden, NICHT in den von Instant generierten
 * instant-*.liquid Sektionen).
 *
 * Zweck: Der Instant-Header rendert seinen Warenkorb-Zähler serverseitig als
 *   <span data-instant-dynamic-content-source="CART_COUNT" ...>
 * und aktualisiert ihn nie clientseitig. Dieses Skript hält alle solchen
 * Spans nach jedem Warenkorb-Update (Hinzufügen / Menge / Entfernen) aktuell.
 *
 * Zwei Trigger (Gürtel + Hosenträger):
 *  1. Dawn-PubSub `cartUpdate` (von product-form.js und cart.js gefeuert).
 *  2. MutationObserver auf dem cart-drawer .drawer__inner – dieser Container
 *     wird bei jeder Warenkorb-Änderung neu gerendert, fängt also auch Fälle
 *     ab, in denen kein PubSub-Event ankommt.
 * Beide lösen ein gedrosseltes fetch('/cart.js') aus.
 */
(function () {
  var COUNT_SELECTOR = '[data-instant-dynamic-content-source="CART_COUNT"]';

  function computeInstantCount(cart) {
    if (!cart) return 0;
    // Instant filtert serverseitig Positionen mit Property `_instant-hidden`
    // (z. B. App-Geschenke) heraus – hier nachbilden, sonst fallback item_count.
    if (Array.isArray(cart.items)) {
      var total = 0;
      cart.items.forEach(function (item) {
        var hidden = item.properties && (item.properties['_instant-hidden'] === 'true' || item.properties['_instant-hidden'] === true);
        if (!hidden) total += item.quantity || 0;
      });
      return total;
    }
    return cart.item_count || 0;
  }

  function applyCount(count) {
    var spans = document.querySelectorAll(COUNT_SELECTOR);
    for (var i = 0; i < spans.length; i++) {
      var span = spans[i];
      // gleiche Darstellung wie das Instant-Liquid: ab 100 leer lassen
      span.textContent = count > 0 && count < 100 ? String(count) : (count >= 100 ? '' : '');
      span.style.display = count > 0 ? '' : 'none';
    }
  }

  var inFlight = false;
  var pending = false;
  function syncFromServer() {
    if (inFlight) {
      pending = true;
      return;
    }
    inFlight = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyCount(computeInstantCount(cart)); })
      .catch(function () { /* still – Zähler bleibt unverändert */ })
      .finally(function () {
        inFlight = false;
        if (pending) {
          pending = false;
          syncFromServer();
        }
      });
  }

  var debounceTimer = null;
  function syncDebounced() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncFromServer, 250);
  }

  function init() {
    // 1) Dawn-PubSub
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncDebounced);
    }

    // 2) Drawer-Inhalt beobachten (wird bei jeder Cart-Änderung neu gerendert)
    function observeDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || drawer.dataset.fmdCountObserved) return;
      drawer.dataset.fmdCountObserved = '1';
      var observer = new MutationObserver(syncDebounced);
      observer.observe(drawer, { childList: true, subtree: true });
    }
    observeDrawer();

    // Falls der Drawer erst später in den DOM kommt (oder Instant neu rendert)
    if (document.body) {
      var bodyObserver = new MutationObserver(function () { observeDrawer(); });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    // 3) Initialer Abgleich, falls die serverseitige Zahl abweicht
    syncFromServer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
